import { CardState } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { RouteConfig } from 'vue-router';

import RouterView from '@/components/RouterView.vue';
import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import Card from '@/views/card/Card.vue';

export const cardRoute: RouteConfig = {
  path: 'cards',
  name: 'cards',
  redirect: { name: 'cardsByState', params: { state: CardState[CardState.NOT_CONFIRMED] } },
  component: RouterView,
  children: [
    {
      path: ':state',
      name: 'cardsByState',
      component: Card,
      beforeEnter: (to, from, next) => {
        store.commit('breadcrumbs/set', [{ text: 'Karty', disabled: true }]);
        Promise.all([
          store.dispatch('card/list', {
            ...baseFilters(to),
            state: to.params.state,
            collectionPointId: tryParseInt(to.query.collectionPointId)
          }),
          store.dispatch('collectionPoint/list', { count: -1 })
        ])
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy kart.' }));
      }
    }
  ],
  meta: { toolbarTitle: 'Karty mieszkańców' }
};
